import { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
//datepicker
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
//ckeditor
import { CKEditor } from "ckeditor4-react";
import { editorConfig, SwalError } from "../../../../utils/constants";

import {
  create,
  getAll,
  getById,
  saveFile,
  update,
} from "../../../../utils/requests/dynamicReq";
import { paths } from "../../../../utils/paths";
import {
  separateRoles,
  cleanUsers,
  uniqueUsers,
  buildInvestigatorCoreFacility,
} from "../../../../utils/auxiliar/manageCoreFacilities";

//middleware
import moment from "moment";
import produce from "immer";
import Swal from "sweetalert2";
import Axios from "axios";
import { validate } from "./validations";
import { ROUTES } from "../../../../utils/routes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { useDelete } from "../../../../utils/hooks/useDelete";
import { useSelector } from "react-redux";
import { FileUploader } from "../../../../components/FileUploader/FileUploader";
registerLocale("es", es);

export const ManageCoreFacility = () => {
  let { isAdmin, userRoleId, staffId } = useSelector(({ user }) => user);
  const { COREFACILITIES, INVESTIGATORS, investigatorCOREFACILITIES } = paths;
  const { id } = useParams();
  const history = useHistory();
  const { deleteIt } = useDelete();

  const [isCreate, setIsCreate] = useState(false);
  //userForm
  const [nombreEs, setNombreEs] = useState("");
  const [nombreEn, setNombreEn] = useState("");
  const [descripcionEs, setDescripcionEs] = useState("");
  const [descripcionEn, setDescripcionEn] = useState("");
  const [infoEs, setInfoEs] = useState("");
  const [infoEn, setInfoEn] = useState("");
  const [image, setImage] = useState();
  const [serviciosEs, setServiciosEs] = useState("");
  const [serviciosEn, setServiciosEn] = useState("");
  const [equipamientoEs, setEquipamientoEs] = useState("");
  const [equipamientoEn, setEquipamientoEn] = useState("");
  const [enlaces, setEnlaces] = useState("");
  const [publicaciones, setPublicaciones] = useState("");
  const [tarifasEs, setTarifasEs] = useState("");
  const [tarifasEn, setTarifasEn] = useState("");
  const [guiasEs, setGuiasEs] = useState("");
  const [guiasEn, setGuiasEn] = useState("");
  const [ips, setIps] = useState([]);
  const [chosenIps, setChosenIps] = useState([]);
  const [participants, setParticipants] = useState([]);
  const [chosenParticipants, setChosenParticipants] = useState([]);
  const [message, setMessage] = useState("");
  const [allowedEdit, setAllowedEdit] = useState(false);
  const isMounted = useRef(false);
  const source = Axios.CancelToken.source();
  const [datosCargados, setDatosCargados] = useState(false);
  const [coreFacility, setCoreFacility] = useState()
  useEffect(() => {
    isMounted.current = true;
    const { pathname } = history.location;
    pathname.includes("crear") ? loadDefaultData() : loadEditData();
    return () => {
      isMounted.current = false;
      source.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadDefaultData = async () => {
    try {
      let investigators = await getAll(INVESTIGATORS, source);

      if (isMounted.current) {
        setIsCreate(true);
        setAllowedEdit(true);
        setTimeout(() => filterAdmins(investigators), 250);
      }
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const filterAdmins = (investigators) => {
    let newinvestigators = investigators.filter(
      (u) =>
        u.email !== "admin@admin.com" &&
        u.email !== "sombradoble@sombradoble.es"
    );
    setIps(newinvestigators);
    setParticipants(newinvestigators);
  };

  const loadEditData = async () => {
    try {
      let response = await getById(COREFACILITIES, id, source);
      isMounted.current && buildObjToLoad(response);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };
  const buildObjToLoad = async (p) => {
    setNombreEs(p.nombreEs);
    setNombreEn(p.nombreEn);
    setDescripcionEs(p.descripcionEs);
    setDescripcionEn(p.descripcionEn);
    setInfoEs(p.infoEs);
    setInfoEn(p.infoEn);
    setServiciosEs(p.serviciosEs);
    setServiciosEn(p.serviciosEn);
    setEquipamientoEs(p.equipamientoEs);
    setEquipamientoEn(p.equipamientoEn);
    setEnlaces(p.enlaces);
    setPublicaciones(p.publicaciones);
    setTarifasEs(p.tarifasEs);
    setTarifasEn(p.tarifasEn);
    setGuiasEs(p.guiasEs);
    setGuiasEn(p.guiasEn);
    setImage(p.image)
    setCoreFacility(p)
    let investigators = await getAll(INVESTIGATORS, source);
    if (isMounted.current) {
      setIpsDisplay(p, investigators);
      setParticipantsDisplay(p, investigators);
      setAllowedEdit(true);
      setDatosCargados(true);
    }
  };

  const setIpsDisplay = async ({ staffCoreFacilities }, investigators) => {
    const { ips, participants } = separateRoles(staffCoreFacilities);
    setChosenIps(ips);
    //get unassigned investigators by comparing with chosenIps
    let rawIps = uniqueUsers(investigators, ips);
    let unassignedIps = uniqueUsers(rawIps, participants);
    setIps(cleanUsers(unassignedIps));
  };

  const setParticipantsDisplay = async (
    { staffCoreFacilities },
    investigators
  ) => {
    const { ips, participants } = separateRoles(staffCoreFacilities);
    setChosenParticipants(participants);
    //get unassigned investigators by comparing with participants
    let rawInvs = uniqueUsers(investigators, participants);
    let unassignedInvs = uniqueUsers(rawInvs, ips);
    setParticipants(cleanUsers(unassignedInvs));
  };

  // HANDLE INVESTIGATORS
  const addInvestigator = (ip, investigator) => {
    ip = JSON.parse(ip);
    investigator === "IP"
      ? //add chosenIp
        setChosenIps((state) =>
          produce(state, (drafState) => {
            drafState.push(ip);
          })
        )
      : //add chosenParticipant
        setChosenParticipants((state) =>
          produce(state, (drafState) => {
            drafState.push(ip);
          })
        );
    setIps((state) =>
      produce(state, (drafState) => drafState.filter(({ id }) => id !== ip.id))
    );
    setParticipants((state) =>
      produce(state, (drafState) => drafState.filter(({ id }) => id !== ip.id))
    );
  };
  const removeInvestigator = (ip, investigator) => {
    if (!allowedEdit) return;
    investigator === "IP"
      ? // remove chosenIp
        setChosenIps((state) =>
          produce(state, (drafState) =>
            drafState.filter(({ id }) => id !== ip.id)
          )
        )
      : setChosenParticipants((state) =>
          produce(state, (drafState) =>
            drafState.filter(({ id }) => id !== ip.id)
          )
        );
    setIps((state) =>
      produce(state, (drafState) => {
        drafState.push(ip);
      })
    );
    setParticipants((state) =>
      produce(state, (drafState) => {
        drafState.push(ip);
      })
    );
  };
  const handleSubmit = () => {
    const coreFacility = build();
    const notValid = validate(coreFacility);
    //     if (notValid) {
    //       setMessage(notValid);
    //       setTimeout(() => setMessage(""), 4000);
    //       return;
    //     }
    let question = isCreate ? "crear una" : "editar esta";
    Swal.fire({
      icon: "question",
      text: `¿Quieres ${question} unidad de apoyo?`,
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(
      ({ isConfirmed }) => isConfirmed && handleConfirmation(coreFacility)
    );
  };
  const handleConfirmation = (coreFacility) => {
    let createOrUpdate = isCreate
      ? create(COREFACILITIES, coreFacility, source)
      : update(COREFACILITIES, id, coreFacility, source);
    createOrUpdate
      .then(async ({ id: coreFacilityId }) => {
        const investigatorCoreFacilities = buildInvestigatorCoreFacility(
          chosenParticipants,
          chosenIps,
          coreFacilityId
        );
        await create(
          `${investigatorCOREFACILITIES}/${coreFacilityId}`,
          investigatorCoreFacilities,
          source
        );
        let createOrUpdateText = isCreate ? "creada" : "editada";
        Swal.fire({
          icon: "success",
          text: `Unidad de apoyo ${createOrUpdateText} correctamente.`,
        });
        if (typeof image !== "string") {
           const formData = new FormData();
           formData.append("image", image);
                await saveFile(COREFACILITIES, coreFacilityId, "image", formData, source);
              }       
              
        history.push(`${ROUTES.CoreFacilities.all}/${coreFacilityId}`);
        isMounted.current && setIsCreate(false);
      })
      .catch(() => Swal.fire({ icon: "error", text: SwalError }));
  };
  const build = () => {
    const coreFacility = {
      nombreEs,
      nombreEn,
      descripcionEs,
      descripcionEn,
      infoEs,
      infoEn,
      serviciosEs,
      serviciosEn,
      equipamientoEs,
      equipamientoEn,
      enlaces,
      publicaciones,
      tarifasEs,
      tarifasEn,
      guiasEs,
      guiasEn,
    };
    return coreFacility;
  };
  const editDeleteButtons = () => {
    if (isCreate) {
      return (
        <button className="baseBtn" onClick={handleSubmit}>
          Crear Unidad de apoyo
        </button>
      );
    }
    const isPrincipal = coreFacility?.staffCoreFacilities?.some(
      (member) => member.staff?.id === staffId && member.coreFacilityRole === "ip"
    );
    const coreEditPermission = coreFacility?.staffCoreFacilities?.some(
      (member) => member.staff?.id === staffId && member.staff?.edicionUnidad === true
    );


    if ((isPrincipal && coreEditPermission) || isAdmin) {
      return (
        <>
          <button className="baseBtn" onClick={handleSubmit}>
            Guardar cambios
          </button>
          <button
            className="smallBtn btn-danger ml-1"
            onClick={() =>
              deleteIt(COREFACILITIES, id, ROUTES.CoreFacilities.all, source)
            }
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </>
      );
    }
  }

  return (
    <div className="centerPage">
      {(isAdmin || userRoleId === 3 || userRoleId === 2) && (
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col d-flex justify-content-between">
              <div>
                <h3>Unidad de apoyo </h3>
              </div>
              <div>{editDeleteButtons()}</div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12 text-center text-danger">
              <span>{message}</span>
            </div>
          </div>
          <div className=" form-row mt-2 ">
            <div className="col-6 d-flex justify-content-center">
              <FileUploader handleFile={setImage} image={image} />
            </div>
            <div className="col-6  d-flex flex-column  ">
              <small>Nombre en español </small>
              <input
                type="text"
                className="form-control"
                placeholder="Nombre español"
                value={nombreEs}
                onChange={({ target: { value } }) => setNombreEs(value)}
              />
              <small>Nombre en inglés </small>
              <input
                type="text"
                className="form-control"
                placeholder="Nombre inglés"
                maxLength="500"
                value={nombreEn}
                onChange={({ target: { value } }) => setNombreEn(value)}
              />
            </div>
          </div>
          <div className="form-row mt-4">
            <div className="col">
              <select
                className="form-control input"
                value={""}
                onChange={({ target: { value } }) =>
                  addInvestigator(value, "IP")
                }
              >
                <option value={""}>
                  Responsables científicos
                </option>
                {ips?.map((i) => (
                  <option key={i.id} value={JSON.stringify(i)}>
                    {`${i.apellidos} , ${i.nombre}`}
                  </option>
                ))}
              </select>
              {chosenIps?.map((ip) => (
                <span
                  key={ip.id}
                  style={{ cursor: "pointer" }}
                  className="badge badge-info badge-blue-color mr-1 mt-3  "
                  onClick={() => removeInvestigator(ip, "IP")}
                >
                  {`${ip.nombre} ${ip.apellidos}`} X
                </span>
              ))}
            </div>
            <div className="col">
              <select
                className="form-control input"
                value={""}
                onChange={({ target: { value } }) =>
                  addInvestigator(value, "PARTICIPANT")
                }
              >
                <option value={""}>Responsables técnicos</option>
                {participants?.map((i) => (
                  <option key={i.id} value={JSON.stringify(i)}>
                    {`${i.apellidos} , ${i.nombre}`}
                  </option>
                ))}
              </select>
              {chosenParticipants?.map((participant) => (
                <span
                  key={participant.id}
                  style={{ cursor: "pointer" }}
                  className="badge badge-info badge-blue-color mr-1 mt-3  "
                  onClick={() => removeInvestigator(participant, "PARTICIPANT")}
                >
                  {`${participant.nombre} ${participant.apellidos} `}X
                </span>
              ))}
            </div>
          </div>

          {isCreate ? (
            <>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Descripción en español</small>
                  <CKEditor
                    initData={descripcionEs}
                    config={editorConfig}
                    onChange={({ editor }) =>
                      setDescripcionEs(editor.getData())
                    }
                  />
                </div>
              </div>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Descripción en inglés</small>
                  <CKEditor
                    initData={descripcionEn}
                    config={editorConfig}
                    onChange={({ editor }) =>
                      setDescripcionEn(editor.getData())
                    }
                  />
                </div>
              </div>
            </>
          ) : (
            datosCargados && (
              <>
                <div className="form-row mt-4">
                  <div className="col">
                    <small>Descripción en español</small>
                    <CKEditor
                      initData={descripcionEs}
                      config={editorConfig}
                      onChange={({ editor }) =>
                        setDescripcionEs(editor.getData())
                      }
                    />
                  </div>
                </div>
                <div className="form-row mt-4">
                  <div className="col">
                    <small>Descripción en inglés</small>
                    <CKEditor
                      initData={descripcionEn}
                      config={editorConfig}
                      onChange={({ editor }) =>
                        setDescripcionEn(editor.getData())
                      }
                    />
                  </div>
                </div>
              </>
            )
          )}

          {isCreate ? (
            <>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Información en español</small>
                  <CKEditor
                    initData={infoEs}
                    config={editorConfig}
                    onChange={({ editor }) => setInfoEs(editor.getData())}
                  />
                </div>
              </div>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Información en inglés</small>
                  <CKEditor
                    initData={infoEn}
                    config={editorConfig}
                    onChange={({ editor }) => setInfoEn(editor.getData())}
                  />
                </div>
              </div>
            </>
          ) : (
            datosCargados && (
              <>
                <div className="form-row mt-4">
                  <div className="col">
                    <small>Información en español</small>
                    <CKEditor
                      initData={infoEs}
                      config={editorConfig}
                      onChange={({ editor }) => setInfoEs(editor.getData())}
                    />
                  </div>
                </div>
                <div className="form-row mt-4">
                  <div className="col">
                    <small>Información en inglés</small>
                    <CKEditor
                      initData={infoEn}
                      config={editorConfig}
                      onChange={({ editor }) => setInfoEn(editor.getData())}
                    />
                  </div>
                </div>
              </>
            )
          )}

          {isCreate ? (
            <>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Servicios en español</small>
                  <CKEditor
                    initData={serviciosEs}
                    config={editorConfig}
                    onChange={({ editor }) => setServiciosEs(editor.getData())}
                  />
                </div>
              </div>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Servicios en inglés</small>
                  <CKEditor
                    initData={serviciosEn}
                    config={editorConfig}
                    onChange={({ editor }) => setServiciosEn(editor.getData())}
                  />
                </div>
              </div>
            </>
          ) : (
            datosCargados && (
              <>
                <div className="form-row mt-4">
                  <div className="col">
                    <small>Servicios en español</small>
                    <CKEditor
                      initData={serviciosEs}
                      config={editorConfig}
                      onChange={({ editor }) =>
                        setServiciosEs(editor.getData())
                      }
                    />
                  </div>
                </div>
                <div className="form-row mt-4">
                  <div className="col">
                    <small>Servicios en inglés</small>
                    <CKEditor
                      initData={serviciosEn}
                      config={editorConfig}
                      onChange={({ editor }) =>
                        setServiciosEn(editor.getData())
                      }
                    />
                  </div>
                </div>
              </>
            )
          )}

          {isCreate ? (
            <>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Equipamientos en español</small>
                  <CKEditor
                    initData={equipamientoEs}
                    config={editorConfig}
                    onChange={({ editor }) =>
                      setEquipamientoEs(editor.getData())
                    }
                  />
                </div>
              </div>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Equipamientos en inglés</small>
                  <CKEditor
                    initData={equipamientoEn}
                    config={editorConfig}
                    onChange={({ editor }) =>
                      setEquipamientoEn(editor.getData())
                    }
                  />
                </div>
              </div>
            </>
          ) : (
            datosCargados && (
              <>
                <div className="form-row mt-4">
                  <div className="col">
                    <small>Equipamientos en español</small>
                    <CKEditor
                      initData={equipamientoEs}
                      config={editorConfig}
                      onChange={({ editor }) =>
                        setEquipamientoEs(editor.getData())
                      }
                    />
                  </div>
                </div>
                <div className="form-row mt-4">
                  <div className="col">
                    <small>Equipamientos en inglés</small>
                    <CKEditor
                      initData={equipamientoEn}
                      config={editorConfig}
                      onChange={({ editor }) =>
                        setEquipamientoEn(editor.getData())
                      }
                    />
                  </div>
                </div>
              </>
            )
          )}

          {isCreate ? (
            <>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Enlaces</small>
                  <CKEditor
                    initData={enlaces}
                    config={editorConfig}
                    onChange={({ editor }) => setEnlaces(editor.getData())}
                  />
                </div>
              </div>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Publicaciones</small>
                  <CKEditor
                    initData={publicaciones}
                    config={editorConfig}
                    onChange={({ editor }) =>
                      setPublicaciones(editor.getData())
                    }
                  />
                </div>
              </div>
            </>
          ) : (
            datosCargados && (
              <>
                <div className="form-row mt-4">
                  <div className="col">
                    <small>Enlaces</small>
                    <CKEditor
                      initData={enlaces}
                      config={editorConfig}
                      onChange={({ editor }) => setEnlaces(editor.getData())}
                    />
                  </div>
                </div>
                <div className="form-row mt-4">
                  <div className="col">
                    <small>Publicaciones</small>
                    <CKEditor
                      initData={publicaciones}
                      config={editorConfig}
                      onChange={({ editor }) =>
                        setPublicaciones(editor.getData())
                      }
                    />
                  </div>
                </div>
              </>
            )
          )}

          {isCreate ? (
            <>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Tarifas en español</small>
                  <CKEditor
                    initData={tarifasEs}
                    config={editorConfig}
                    onChange={({ editor }) => setTarifasEs(editor.getData())}
                  />
                </div>
              </div>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Tarifas en inglés</small>
                  <CKEditor
                    initData={tarifasEn}
                    config={editorConfig}
                    onChange={({ editor }) => setTarifasEn(editor.getData())}
                  />
                </div>
              </div>
            </>
          ) : (
            datosCargados && (
              <>
                <div className="form-row mt-4">
                  <div className="col">
                    <small>Tarifas en español</small>
                    <CKEditor
                      initData={tarifasEs}
                      config={editorConfig}
                      onChange={({ editor }) => setTarifasEs(editor.getData())}
                    />
                  </div>
                </div>
                <div className="form-row mt-4">
                  <div className="col">
                    <small>Tarifas en inglés</small>
                    <CKEditor
                      initData={tarifasEn}
                      config={editorConfig}
                      onChange={({ editor }) => setTarifasEn(editor.getData())}
                    />
                  </div>
                </div>
              </>
            )
          )}

          {isCreate ? (
            <>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Guias en español</small>
                  <CKEditor
                    initData={guiasEs}
                    config={editorConfig}
                    onChange={({ editor }) => setGuiasEs(editor.getData())}
                  />
                </div>
              </div>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Guias en inglés</small>
                  <CKEditor
                    initData={guiasEn}
                    config={editorConfig}
                    onChange={({ editor }) => setGuiasEn(editor.getData())}
                  />
                </div>
              </div>
            </>
          ) : (
            datosCargados && (
              <>
                <div className="form-row mt-4">
                  <div className="col">
                    <small>Guias en español</small>
                    <CKEditor
                      initData={guiasEs}
                      config={editorConfig}
                      onChange={({ editor }) => setGuiasEs(editor.getData())}
                    />
                  </div>
                </div>
                <div className="form-row mt-4">
                  <div className="col">
                    <small>Guias en inglés</small>
                    <CKEditor
                      initData={guiasEn}
                      config={editorConfig}
                      onChange={({ editor }) => setGuiasEn(editor.getData())}
                    />
                  </div>
                </div>
              </>
            )
          )}
        </div>
      )}
    </div>
  );
};
